"use client"

import * as React from "react"
import { PieChart, Pie, LabelList, Sector, Cell, ResponsiveContainer } from 'recharts';
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "src/@/components/ui/card"
import {
    ChartContainer,
    ChartLegend,
    ChartLegendContent,
    ChartTooltip,
    ChartTooltipContent,
} from "src/@/components/ui/chart"
import EmptyContentGhost from "src/components/EmptyContentGhost"


const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff7300', '#a4de6c', '#d0ed57', '#83a6ed', '#8dd1e1', '#ff9896', '#d62728'];

const renderActiveShape = (props) => {
    const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent } = props;
    
    return (
        <g>
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={fill}
            />
            <Sector
                cx={cx}
                cy={cy}
                startAngle={startAngle}
                endAngle={endAngle}
                innerRadius={outerRadius + 6}
                outerRadius={outerRadius + 10}
                fill={fill}
            />
        </g>
    );
};

export function GraficoCrmMotivoPerdas({ chartData }) {
    const [activeIndex, setActiveIndex] = React.useState(0);
    const colors = COLORS.slice(0, chartData.length);

    const onPieEnter = (_, index) => {
        setActiveIndex(index);
    };

    const chartConfig = chartData.reduce((config, item, index) => {
        config[item.motivo] = {
            label: item.motivo,
            color: colors[index],
        };
        return config;
    }, {});

    return (
        <Card className="w-full">
            <CardHeader className="flex items-center gap-2 space-y-0 border-b border-gray-50 py-3 sm:flex-row">
            <h3 className="text-xl font-bold text-gray-800">
            Motivos perdas de leads
        </h3>

            </CardHeader>
            <CardContent>
                {
                    chartData?.length === 0 ? (
                        <EmptyContentGhost />
                    ) : (
                        <ChartContainer
                            config={chartConfig}
                            className="h-[400px] [&_.recharts-text]:fill-background w-full"
                        >
                            <div className="flex h-full w-full flex-row items-center justify-between gap-4">
                                <div className="h-full w-3/4">
                                    <ResponsiveContainer width="100%" height="100%">
                                        <PieChart>
                                            <ChartTooltip
                                                content={<ChartTooltipContent nameKey="motivo" dataKey="total" />}
                                            />
                                            <Pie 
                                                data={chartData} 
                                                dataKey="total"
                                                activeIndex={activeIndex}
                                                activeShape={renderActiveShape}
                                                onMouseEnter={onPieEnter}
                                                innerRadius="60%"
                                                outerRadius="80%"
                                                paddingAngle={2}
                                                animationBegin={0}
                                                animationDuration={1500}
                                                cx="50%"
                                                cy="50%"
                                            >
                                                {chartData.map((entry, index) => (
                                                    <Cell
                                                        key={`cell-${index}`}
                                                        fill={colors[index]}
                                                    />
                                                ))}
                                            </Pie>
                                        </PieChart>
                                    </ResponsiveContainer>
                                </div>
                                <div className="w-1/4 overflow-y-auto max-h-[400px] flex flex-col gap-3 p-4">
                                    {chartData.map((entry, index) => (
                                        <div key={index} className="flex items-center gap-2">
                                            <div 
                                                className="w-4 h-4 rounded-sm" 
                                                style={{ backgroundColor: colors[index] }}
                                            />
                                            <div className="flex flex-col">
                                                <span className="text-xs text-muted-foreground">{entry.motivo}</span>
                                                <span className="text-sm  font-medium">{entry.total}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </ChartContainer>
                    )
                }

            </CardContent>
        </Card>
    )
}
